var _defs, _circle, _circle2, _line, _rect, _line2, _path, _line3, _path2, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "tick_empty",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .subsciptionline {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .subscriptionfill {\n        fill: #333;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "subscriptionfill",
    cx: 17.2,
    cy: 8.86,
    r: 1.56
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "subscriptionfill",
    cx: 33.86,
    cy: 8.86,
    r: 1.56
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionline",
    x1: 3.14,
    y1: 12.51,
    x2: 46.87,
    y2: 12.51
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "subsciptionline",
    x: 3.14,
    y: 5.22,
    width: 43.74,
    height: 39.57,
    rx: 6.25,
    ry: 6.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionline",
    x1: 35.52,
    y1: 24.07,
    x2: 35.52,
    y2: 18.91
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "subsciptionline",
    d: "M14.49,24.09c1.76-4.06,5.81-6.9,10.52-6.9h0c4.71,0,8.75,2.84,10.52,6.9"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "subsciptionline",
    x1: 14.5,
    y1: 33.23,
    x2: 14.5,
    y2: 38.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "subsciptionline",
    d: "M35.52,33.21c-1.76,4.06-5.81,6.9-10.52,6.9h0c-4.7,0-8.75-2.83-10.51-6.88"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "subsciptionline",
    points: "19.81 30.51 23.26 34.61 30.42 25.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.34289d3baa35952319338c229dd71ae1.svg";
export { ForwardRef as ReactComponent };